import { render, staticRenderFns } from "./DashDemandBalances.vue?vue&type=template&id=5c8aa226&scoped=true&"
import script from "./DashDemandBalances.vue?vue&type=script&lang=js&"
export * from "./DashDemandBalances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8aa226",
  null
  
)

export default component.exports